import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from '@progress/kendo-react-layout';

import styles from './style.module.scss';

const AddWidgetButton = ({ onClick }: { onClick: () => void }) => {
    const { t } = useTranslation();
    return (
        <Card
            className="widget k-display-flex k-align-items-center k-justify-content-center k-cursor-pointer k-mt-1 k-mr-1 k-mb-1"
            data-testid="add-widget-button"
            onClick={() => onClick()}
            style={{ height: '86px', width: '175px' }}
        >
            <span className={styles.addWidgetButton}>+ {t('addNew')}</span>
        </Card>
    );
};

export default AddWidgetButton;
